import styled from 'styled-components';

import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import First from '../../../assets/images/icons/No1.png';
import Second from '../../../assets/images/icons/No2.png';
import Three from '../../../assets/images/icons/No3.png';
import defaultAvatar from '../../../assets/images/icons/user-avater.png';

const RankIMG = styled.img`
  width: 58px;
  height: 38px;
  margin:auto 0;
`;

export const CardTitle = styled.div`
  position: relative;
  font-size: 24px;
  margin-top: 20px;
  font-weight: 600;
  padding-left: 14px;
  ::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 80%;
    width: 5px;
    background-color: #40a9ff;
  }
`;

const AuthorAvatar = styled.img`
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  margin-left: 20px;
  margin-right: 20px;
`;

const CommonTable = ({ data, loading, title, pagination, currentPage}) => {
  const { t } = useTranslation();
  const Columns = [
    {
      title: (
        <span
          style={{
            fontWeight: 400,
          }}
        >
          {t('AuthorTable.title')}
        </span>
      ),
      dataIndex: 'name',
      key: 'name',
      render: (_, { index, user }) => (
        <>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '58px auto',
              maxWidth: '500px',
              overflow: 'hidden',
            }}
          >
            {currentPage === 1 && index === 0 ? (
              <RankIMG src={First} />
            ) : currentPage === 1 && index === 1 ? (
              <RankIMG src={Second} />
            ) : currentPage === 1 && index === 2 ? (
              <RankIMG src={Three} />
            ) : (
              <span
                style={{
                  fontSize: '16px',
                  lineHeight: '16px',
                  fontWeight: '900',
                  color: 'rgba(255, 255, 255, 0.4)',
                }}
              >
                {/* {index+1} */}
              </span>
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <AuthorAvatar src={user.avatar ? user.avatar : defaultAvatar} />
              <Link
                to={`/whiteHats/${user.name}`}
                style={{
                  color: '#fff',
                  textAlign: 'left',
                  fontWeight: '700',
                  fontSize: '16px',
                  lineHeight: '16px',
                }}
              >
                {user.name}
              </Link>
            </div>
          </div>
        </>
      ),
      width: 200,
      ellipsis: true,
      align: 'center',
      className: 'common-table-lv author-table-authors',
    },
    {
      title: (
        <span
          style={{
            fontWeight: 400,
          }}
        >
          {t('AuthorTable.reportNumber')}
        </span>
      ),
      dataIndex: 'reports_count',
      key: 'reports_count',
      // width: 120,
      render: (_, { user }) => (
        <span
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '700',
            color: '#FFFFFF',
          }}
        >
          {user.reports_count}
        </span>
      ),
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontWeight: 400,
          }}
        >
          {t('AuthorTable.totalPoints')}
        </span>
      ),
      dataIndex: 'total_points',
      key: 'total_points',
      // width: 120,
      render: (_, { total_points }) => (
        <span
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '700',
            color: '#FFFFFF',
          }}
        >
          {total_points.toLocaleString(navigator.language)}
        </span>
      ),
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontWeight: 400,
          }}
        >
          {t('AuthorTable.rewards')}  (USDC)
        </span>
      ),
      dataIndex: 'rewards',
      key: 'rewards',
      align: 'center',
      render: (_,{ rewards }) => (
        <span
          style={{
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: '700',
          }}
        >
          {rewards.toLocaleString(navigator.language)}
        </span>
      ),
      className: 'common-table-cell-date',
    },
  ];

  return (
    <>
      {title ? <CardTitle>{title}</CardTitle> : null}
      <Table
        columns={Columns}
        dataSource={data}
        pagination={(pagination)}
        loading={loading}
        className="author-table"
        rowKey="index"
        scroll={{
          x: true,
        }}
      />
    </>
  );
};

export default CommonTable;
